export default __webpack_public_path__ + "static/media/safety_rules_bg.f9dcfb91.jpg";